import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { map } from 'rxjs/operators';
import { ApiService, URLS } from './api.service';
import { Agente } from '../models/agente';
import { environment } from '../../environments/environment';

@Injectable()

export class MapaResolver implements Resolve<any> {

  constructor(private apiService: ApiService) {}

  resolve() {
    return this.apiService.get(URLS.AGENTES.GET_AGENTES, '', environment.urlLaravel)
      .pipe(
        map((data) => {
          let AgentesTemp: Agente[] = Array();
          for (let i: number = 0; i < data.length; i++) {
            AgentesTemp[i] = data[i];
            AgentesTemp[i].lat = data[i].telemetrias.latitude
            AgentesTemp[i].lng = data[i].telemetrias.longitude
            AgentesTemp[i].status = data[i].status
            AgentesTemp[i].pronto = data[i].pronto
            AgentesTemp[i].draggable = true
            AgentesTemp[i].icon = data[i].icone
          }
          return { objetosFiltroEfetivo: AgentesTemp };
        })
      );
  }

}


// WEBPACK FOOTER //
// ./src/app/services/mapa-resolver.service.ts